<template>
	<div class="container">
		<h1>{{ id == 'new' ? 'Create' : 'Edit' }} Payment Method</h1>

		<div v-if="loading">Loading payment method...</div>

		<ux-form v-else ref="form">
			<method-form ref="methodForm" :method.sync="method" />
		</ux-form>

		<ul class="ux-btn-list is-horz">
			<li><ux-btn color="primary" :loading="saving" @click="save">Save Payment Method</ux-btn></li>
			<li><ux-btn color="text" :disabled="saving" to="/profile">Back to Profile</ux-btn></li>
		</ul>
	</div>
</template>

<script>
import { mapState } from 'vuex';

import api from 'frontend/api';
import alerts from 'common/alerts';

import MethodForm from 'frontend/payment-methods/comp/PaymentMethodForm.vue';

const defaultMethod = {
	id: 0,
	name: '',
	is_primary: false,
	billing_addr: {},
}

export default {
	components: { MethodForm },

	props: {
		id: { type: [String, Number], required: true }
	},

	data() 
	{
		return {
			method: {},
			loading: true,
			saving: false,
		}
	},

	computed: {
		...mapState({
			methods: state => state.paymentMethods.methods,
		})
	},

	methods: {
		async loadMethod()
		{
			this.loading = true;

			try
			{
				var result = await api.get(`/payment_methods/${this.id}`);
				this.method = { ...result.data.method };
			}
			finally
			{
				this.loading = false;
			}
		},

		async save()
		{
			if (!this.$refs.form.validate())
				return;

			this.saving = true;

			try
			{
				var data = { ...this.method };

				if (this.method.id == 0)
				{
					// get credit card data
					var { nonce, cardData } = await this.$refs.methodForm.getNonce();

					// add to request data
					data.card_token = nonce;
					data.billing_addr = { ...data.billing_addr, postal_code: cardData.billing_postal_code };
					
					await api.post('/payment_methods', { method: data });
				}
				else
				{
					await api.put(`/payment_methods/${this.method.id}`, { method: data });
				}
				
				await alerts.show('Payment method updated successfully', 'Success', 'success');

				this.$router.push('/profile');
			}
			finally
			{
				this.saving = false;
			}
		}
	},

	created()
	{
		if (this.id == 'new')
		{
			this.method = { ...defaultMethod };
			this.loading = false;
		}
		else
		{
			this.loadMethod();
		}
	}
}
</script>